import { ReactNode, createContext, useContext } from "react";

export const TabPanelContext = createContext<{ id: string | undefined }>({
  id: undefined,
});

export const TabBadgesContext = createContext<{
  badges: Record<string, ReactNode>;
  setBadge(id: string, badge?: ReactNode): void;
}>({
  badges: {},
  setBadge() {},
});

export function useCurrentTabBadge() {
  const { id } = useContext(TabPanelContext);
  const { badges, setBadge } = useContext(TabBadgesContext);

  return {
    badge: id ? badges[id] : undefined,
    setBadge: (badge?: ReactNode) => {
      if (id) {
        setBadge(id, badge);
      }
    },
  };
}
